import React, { useState } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import Menu from "./components/Menu";
import UploadAssets from "./components/UploadAssets";
import BottomMenu from "./components/BottomMenu";
import Produtos from "./components/Produtos";
import PratosDoDia from "./components/PratosDoDia";
import Login from "./components/Login";
import { ProductProvider } from "./ProductContext";
import "./App.css";
import Test from "./components/Test";

function App() {
  const [token, setToken] = useState(localStorage.getItem("token") || ""); // Recupera o token do localStorage
  const navigate = useNavigate();

  const handleLogin = (newToken) => {
    localStorage.setItem("token", newToken); // Salva o token no localStorage
    setToken(newToken);
    navigate("/#admin"); // Redireciona para a página inicial após login
  };

  const handleLogout = () => {
    localStorage.removeItem("token"); // Remove o token do localStorage
    setToken("");
    navigate("/"); // Redireciona para a página inicial após logout
  };

  // Verifica se o hash da URL contém "#admin"
  const showBottomMenu = window.location.hash.includes("#admin");

  return (
    <div style={{ paddingBottom: "60px" }}>
      <ProductProvider>
        <Routes>
          <Route path="/" element={<Menu />} />
          <Route path="/test" element={<Test />} />
          <Route path="/upload-assets" element={<UploadAssets />} />
          <Route path="/produtos" element={<Produtos />} />
          {/* Protege a rota de pratos do dia */}
          <Route
            path="/pratos-do-dia"
            element={token ? <PratosDoDia token={token} /> : <Login setToken={handleLogin} />}
          />
          {/* Tela de Login */}
          <Route path="/login" element={<Login setToken={handleLogin} />} />
        </Routes>
        {/* Exibe o BottomMenu apenas se não estiver no modo admin */}
        {showBottomMenu && (
          <BottomMenu isLoggedIn={!!token} setLoggedIn={handleLogout} />
        )}
      </ProductProvider>
    </div>
  );
}

export default App;
